export const Config = {
  State: {
    initial: 'initial',
    loaded: 'loaded',
    failed: 'failed',
  },
  Status: {
    NotStarted: 'not_started',
    InProgress: 'in_progress',
    Completed: 'completed',
  },
  IsCompleted: (status) => status === Config.Status.Completed,
  I18n: {
    Progress: I18n.t('learning_pathways.progress.label'),
    Completion: (percent) => I18n.t('learning_pathways.progress.completed', {percent: percent}),
    LoadFailed: I18n.t('learning_pathways.collection.load_failed'),
    Empty: I18n.t('learning_pathways.collection.empty'),
    LessonNumber: (number) => I18n.t('learning_pathways.collection.lesson_number', {number: number}),
    Status: (status) => {
      switch (status) {
        case Config.Status.NotStarted:
          return I18n.t('learning_pathways.progress.status.not_started');
        case Config.Status.InProgress:
          return I18n.t('learning_pathways.progress.status.in_progress');
        case Config.Status.Completed:
          return I18n.t('learning_pathways.progress.status.completed');
        default:
          return '';
      }
    },
    Cta: (status) => {
      switch (status) {
        case Config.Status.NotStarted:
          return I18n.t('learning_pathways.collection.cta.not_started');
        case Config.Status.InProgress:
          return I18n.t('learning_pathways.collection.cta.in_progress');
        case Config.Status.Completed:
          return I18n.t('learning_pathways.collection.cta.completed');
        default:
          return I18n.t('learning_pathways.collection.cta.not_started');
      }
    },
  }
};
